import { Box, Typography } from "@mui/material"
import { ArrowBack } from "../../../../../../../components/arrowBack"
import StatusComponent from "../../../../../../../components/status"
import { CustomeIconButton } from "../../../../../../../components/customeIconButton"
import { icons } from "../../../../../../../utils/icons"
import { Settings } from "../../../../../../../components/settings"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { ActivityDetailHeader } from "./types"
import { getStatus } from "../../../../../../../hooks/status"
import { useContextState } from "../../../../../../../hooks/theme"
import { Status } from "../../../../../../../utils/enums"
import { DetailAndUploadOfEvidences } from "../../../../../../../components/detailAndUploadOfEvidences"
import { formatEvidenceToUploadEvidence } from "../../../../../../../components/uploadEvidence/methods"
import { ViewEvidence } from "../../../../../../../components/detailAndUploadOfEvidences/enum"
import { useMemo, useState } from "react"
import { useEvidenceDownload } from "../../../../../../calendar/pages/detail/hooks"
import { Evidence } from "../../../../../../../service/reportFolio/response"

export const DetailHeader = ({ isforcedClosure, isUserWithPermission, evidenceUpload, status = Status.ACTIVE, getEvidence, title, evidenceConfig, activityId, existEvidences, evidences, menu }: ActivityDetailHeader) => {
    const { defaultEvidence, evidencesDrawer, evidencesRequiredAreLoad, setDeletedsEvidencesList, setEvidencesDrawer, setEvidencesRequiredAreLoad, } = evidenceUpload
    const rawEvidences = Object.values(evidences || {}).flat();

    const comments = rawEvidences
        .filter(e => e.type === 5 && e.name)
        .map(e => e.name as string); // asumiendo que name existe si pasa el filtro

    const flattenedEvidences: Evidence[] = [
        ...rawEvidences
            .filter(e => e.type !== 5)
            .map(e => ({
                url: e.src,
                originalname: e.originalName,
                evidenceTypeId: e.type,
            })),
        ...(comments.length > 0 ? [{ comments }] : [])
    ];
    const { disable, downloadEvidences, } = useEvidenceDownload('Evidencias de bitácora', flattenedEvidences);
    const { t } = useTranslation()
    const { colors } = useContextState()
    const showComponent = useMemo(() => status == Status.STARTED || existEvidences, [status, existEvidences])
    const statusInfo = getStatus(status, colors, t)
    const isNoFinisf = status === Status.NOT_FINISHED ? true : false;
    const colorNoFinish = colors.color13
    const [view, setView] = useState<ViewEvidence>(ViewEvidence.DETAIL)
    const styles = useStyles()
    const validateCanUpload = () => {
        if (status == Status.STARTED) {
            if (isUserWithPermission) {
                setView(ViewEvidence.EDIT)
            } else {
                setView(ViewEvidence.DETAIL)
            }
            const response = formatEvidenceToUploadEvidence({ evidenceConfig: evidenceConfig?.evidence, evidencesDetail: evidences })
            defaultEvidence({ evidencesConfig: response, requireList: evidenceConfig?.requireList })
        }
    }

    return (
        <Box>
            <ArrowBack
                label={t('general.goBackToTheList')}
                arrowProps={{ sx: styles.arrow, onClick: () => { window.location.hash = '' } }}
            />
            <Box sx={styles.header}>
                <Typography variant="title_grey_big">{title}</Typography>

                <Box sx={styles.actions}>
                    {isforcedClosure && <StatusComponent color={colors.color12} msg={t('general.forced')} type="chip" size="xs" fit />}
                    <StatusComponent color={isNoFinisf ? colorNoFinish : statusInfo.color} msg={statusInfo.text} type="chip" size="xs" fit />
                    {!!showComponent && (
                        <DetailAndUploadOfEvidences
                            Node={({ payload: { openDrawer } }) => {
                                return (
                                    <CustomeIconButton
                                        title={view == ViewEvidence.DETAIL ? t('general.seeEvidence') : t('loogbook.titles.chargeEvidence')}
                                        icon={icons('clip')}
                                        iconButtonProps={{
                                            color: 'primary',
                                            onClick: () => {
                                                setDeletedsEvidencesList([])
                                                openDrawer()
                                                validateCanUpload()
                                            }
                                        }} />
                                )
                            }}
                            view={view}
                            save={() => { getEvidence({ evidences: evidencesDrawer }) }}
                            detail={{
                                evidences: {
                                    image: evidences?.images,
                                    comment: evidences?.comments,
                                    documents: evidences?.documents,
                                    video: evidences?.video,
                                    sign: evidences?.sign
                                },
                                existEvidences
                            }}
                            upload={{
                                evidencesDrawer,
                                evidencesRequiredAreLoad: evidencesRequiredAreLoad,
                                deletedEvidence: ({ name }) => { setDeletedsEvidencesList(prev => [...prev, name]) },
                                fakeDelete: false,
                                close: () => { },
                                showRequireds: evidenceUpload.showRequireds,
                                setEvidencesDrawer,
                                setEvidencesRequiredAreLoad,
                                uploadName: `logbook/${activityId}`,
                            }}
                            disable={disable}
                            downloadEvidences={downloadEvidences}
                        />
                    )}

                    <Settings
                        menu={menu}
                        icon="moreVert"
                        containerProps={{ sx: { width: 'auto' } }}
                        iconProps={{ sx: { padding: 0 } }}
                    />
                </Box>
            </Box>
        </Box>
    )
}